"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalHeader_1 = require("./GlobalHeader");
exports.default = GlobalHeader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalHeader/index.js
// module id = 1387
// module chunks = 8